import { useState } from "react";

export default function Contact() {
    const [result, setResult] = useState("");

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending...");
        const formData = new FormData(event.target);

        // Add your Web3Forms access key
        formData.append("access_key", "9f211012-5b97-4ade-af83-e0f7f92642ff");

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                setResult("Form submitted successfully!");
                event.target.reset();
            } else {
                setResult("Error submitting form. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            setResult("Error submitting form. Please try again.");
        }
    };

    return (
        <main>
            <section id="contact" className="contact section-bg">
                <div className="container mt-5">
                    <div className="section-title">
                        <h2>Contact</h2>
                        <p>
                            You can contact us by email, phone, or complete the following form
                            to request an information package.
                        </p>
                    </div>

                    <div className="container">
                        <div className="row pt-2 mx-0 justify-content-center">
                            <form
                                id="contact-form"
                                className="w-100 rounded-1 p-4 border bg-white contact-form"
                                onSubmit={onSubmit}
                            >
                                <label className="d-block mb-4">
                                    <span className="form-label d-block">Your name</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        required
                                        maxLength="50"
                                    />
                                </label>

                                <label className="d-block mb-4">
                                    <span className="form-label d-block">Email address</span>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        required
                                        maxLength="30"
                                    />
                                </label>

                                <label className="d-block mb-4">
                                    <span className="form-label d-block">Province</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="province"
                                        maxLength="20"
                                    />
                                </label>

                                <label className="d-block mb-4">
                                    <span className="form-label d-block">Message</span>
                                    <textarea
                                        className="form-control"
                                        name="message"
                                        rows="3"
                                        placeholder="Ask us anything"
                                        maxLength="500"
                                    ></textarea>
                                </label>

                                <div className="mb-3">
                                    <button type="submit" className="btn btn-primary px-3 rounded-3">
                                        Contact Us
                                    </button>
                                </div>
                                <span>{result}</span>
                            </form>

                            {/* Contact info section */}
                            <div className="row mt-5 justify-content-center">
                                <div className="col-lg-10">
                                    <div className="info-wrap">
                                        <div className="row">
                                            <div className="col-lg-4 info">
                                                <i className="bi bi-geo-alt"></i>
                                                <h4>Mail:</h4>
                                                <p>
                                                    UAS Eastern European Adoptions Inc.<br />
                                                    777 Pritchard Avenue<br />
                                                    Winnipeg, MB R2X 0E8
                                                </p>
                                            </div>

                                            <div className="col-lg-4 info mt-4 mt-lg-0">
                                                <i className="bi bi-envelope"></i>
                                                <h4>Email:</h4>
                                                <p>info@uaseeadoption.ca</p>
                                            </div>

                                            <div className="col-lg-4 info mt-4 mt-lg-0">
                                                <i className="bi bi-phone"></i>
                                                <h4>Call:</h4>
                                                <p>(204) 947-2953</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Contact info section */}
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
